import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";

import { museApi } from "../api/museApi";
import { Form_Entity } from "src/entities/form";

const formsAdapter = createEntityAdapter<Form_Entity>();
const initialState = formsAdapter.getInitialState();

export const formEndpoints = museApi.injectEndpoints({
  endpoints: (build) => ({
    getForms: build.query<EntityState<Form_Entity>, void>({
      query: () => `forms`,
      transformResponse: (responseData: Form_Entity[]) => {
        return formsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["forms"],
    }),
    getForm: build.query<Form_Entity, number>({
      query: (id) => `forms/${id}`,
      providesTags: (result, error, id) => [{ type: "forms", id }],
    }),
    createForm: build.mutation<Form_Entity, Partial<Form_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `forms`,
      }),
      invalidatesTags: ["forms"],
    }),
    updateForm: build.mutation<
      void,
      { id: number; body: Partial<Form_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `forms/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "forms", id },
        "forms",
      ],
    }),
    deleteForm: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `forms/${id}`,
      }),
      invalidatesTags: ["forms"],
    }),
  }),
});

export const {
  useGetFormQuery,
  useGetFormsQuery,
  useCreateFormMutation,
  useDeleteFormMutation,
  useUpdateFormMutation,
} = formEndpoints;

export default formEndpoints;
